import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LoginForm } from '../components/auth/LoginForm';

export function LoginPage() {
  const { isAuthenticated } = useAuth();

  // Redirect if already logged in
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="max-w-md mx-auto mt-8">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Form content */}
        <div className="p-6">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Velkommen tilbage
            </h2>
            <LoginForm />
          </div>
        </div>
      </div>

      {/* Info box */}
      <div className="mt-6 p-4 bg-sand border border-sand-400 rounded-lg">
        <p className="text-sm font-bold text-gray-800">Gribklan Social</p>
        <p className="text-sm text-gray-700 mt-1">
          Gribklans sociale platform. Log ind for at se opdateringer fra klanen.
        </p>
        <p className="text-sm text-gray-700 mt-2">
          Hvis du ikke kender dit login, så klik på <span className="font-semibold">Glemt password</span>, så modtager du det på mail.
        </p>
      </div>
    </div>
  );
}
